<template>
  <el-tabs @tab-click="onChangeTab" type="border-card" value="activeChannels">
    <el-tab-pane label="Active Channels" name="activeChannels">
      <channel-list 
        :channels="channels" 
        :active="activeChannelTab === 'activeChannels'"
        @deactivateChannel="deactivateChannel"
      />
    </el-tab-pane>
    <el-tab-pane label="Inactive Channels" name="inactiveChannels">
      <channel-list 
        :channels="channels" 
        :active="activeChannelTab === 'activeChannels'" 
        @activateChannel="activateChannel"
      />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import ChannelList from '@/components/channel/ChannelList';

export default {
  name: 'Channels',
  components: { ChannelList },
  props: {
    channels: {
      type: Array,
      default: () => [],
      required: true,
    },
    activeChannelTab: {
      type: String,
      default: 'inactiveChannels',
    },
  },
  methods: {
    onChangeTab({ name }) {
      this.$emit('onChangeTab', { activeChannelTab: name });
    },

    activateChannel(channel) {
      this.$store.dispatch('channel/updateChannel', { ...channel, live: true });
    },

    deactivateChannel(channel) {
      this.$confirm(`Are you sure you want to deactivate channel: ${channel.handle}`).then(() => {
        this.$store.dispatch('channel/updateChannel', { ...channel, live: false });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Channels.vue?6608fbcc